import React, { useEffect, useState, useRef } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
// import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import Spinner from "react-bootstrap/Spinner";

//API
import ItemService from "../../../../services/supplier_appCommonService";
import SupplierConstants from "../../../../common/SupplierConstants";
import DataTable from "react-data-table-component";
import { currencyFormat } from "../../../../common/Validations";
import toast from "react-hot-toast";

import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import { useDispatch } from "react-redux";
import { getGoodsReceivedNote } from "../../../../redux/feature/supplier_app/purchasingSlice";
import Constants from "../../../../common/SupplierConstants";

const GRNInvoiceUploadModal = React.forwardRef((props, ref) => {
  // Show an input field only when it has an available (non-empty, non-zero) value
  const hasValue = (val) =>
    val !== null &&
    val !== undefined &&
    val !== "" &&
    val !== "0" &&
    val !== "0.00" &&
    !(Number(val) === 0);
  // A line item is worth showing only if it carries actual invoice data (item
  // code, HSN, qty, rate or amount). Fully-empty OCR rows (e.g. a blank second
  // line) are hidden from the table.
  const hasLineItemValues = (row) =>
    [
      row?.itemCode,
      row?.hsnSac,
      row?.quantity,
      row?.rate,
      row?.taxableValue,
      row?.total,
    ].some((v) => v !== null && v !== undefined && v !== "");
  const fileInputRef = useRef(null);
  // Generation token so a cancelled OCR upload ignores its in-flight response
  const uploadTokenRef = useRef(0);
  const [file, setFile] = useState(null);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);

  const dispatch = useDispatch();

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const modalData = {
    title: "GRN Creation",
    successMsg: "",
  };

  const [parentInfo, setParentInfo] = useState();
  const [uploadStatus, setUploadStatus] = useState(false);
  const [viewInvoiceDataStatus, setViewInvoiceDataStatus] = useState(false);
  const [getInvoiceLineItem, setInvoiceLineItem] = useState([]);

  // Line-item edit popup state
  const [editingItem, setEditingItem] = useState(null);
  const [showItemModal, setShowItemModal] = useState(false);

  const [getHeaderData, setHeaderData] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [totalOrderQuantity, setTotalOrderQuantity] = useState(0);

  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [wasModalShown, setWasModalShown] = useState(false);
  const [ocrInvoiceData, setOcrInvoiceData] = useState({});

  const [invoiceData, setInvoiceData] = useState({
    vendorInvoiceNo: "",
    vendorInvoiceDate: "",
    vendorBasicValue: "",
    vendorTotalInvoiceValue: "",
    dispInvoiceStatusHeader: "",
    dispCreatedBy: "",
    dispCreatedByName: "",
    deliveryName: "",
    dispTotalQty: "",
    dispBasicPricePerUnit: "",
    dispBasicPrice: "",
    dispCGST: "",
    dispSGST: "",
    dispTransporterCode: "",
    dispTransporterName: "",
    dispVehieleRegNo: "",
    dispCustomerCode: "",
    igst: "",
    supplierGSTIN: "",
    supplierPAN: "",
    supplierPhone: "",
    taxAmountInWords: "",
    items: [],
    dispCompanyBankDetails: [],
    invoiceBillDocument: "",
    purchasingDocumentNr: "",
    purchasingDocumentDate: "",
    purchasingDocumentValue: "",
    currencyCode: "",
    currency: "",
    vendorCode: "",
    vendorName: "",
    paymentTerms: "",
    incoTerms: "",
    companyCodeCode: "",
    purchaseType: "",
    invoiceType: "",
    purchaseOrderNumber: "",
  });

  // ---------------------------------------------------------------------------
  // Invoice Items grid — columns are built from "active grid fields". Each
  // active field becomes one editable column of the grid; the user can add /
  // remove default fields and create custom fields through the "Add Items"
  // popup (see below). Values typed in any cell are written straight back to
  // the matching line item (inline editing).
  // ---------------------------------------------------------------------------

  // Default fields the user can toggle for the Invoice Items grid. `key` is the
  // property name used on each OCR line item / PO line (row[key]).
  const LINE_ITEM_FIELD_OPTIONS = [
    { key: "itemCode", label: "Item Code", type: "text" },
    { key: "description", label: "Description", type: "text" },
    { key: "hsnSac", label: "HSN/SAC", type: "text" },
    { key: "unit", label: "Unit", type: "text" },
    { key: "quantity", label: "Qty", type: "number" },
    { key: "rate", label: "Rate", type: "number" },
    { key: "cgstAmount", label: "CGST Amt", type: "number" },
    { key: "cgstPercent", label: "CGST %", type: "number" },
    { key: "sgstAmount", label: "SGST Amt", type: "number" },
    { key: "sgstPercent", label: "SGST %", type: "number" },
    { key: "discount", label: "Discount", type: "number" },
    { key: "igstAmount", label: "IGST Amt", type: "number" },
    { key: "igstPercent", label: "IGST %", type: "number" },
    { key: "taxableValue", label: "Taxable Value", type: "number" },
    { key: "total", label: "Total", type: "number" },
    { key: "cess", label: "Cess", type: "number" },
  ];

  const [activeGridFields, setActiveGridFields] = useState([]);
  const [showAddFieldsModal, setShowAddFieldsModal] = useState(false);
  const [fieldDraft, setFieldDraft] = useState([]);
  const [customFieldLabel, setCustomFieldLabel] = useState("");
  // "Fill Value" popup — set one value for a whole column across all current
  // line items at once. Draft is { [fieldKey]: typedValue }.
  const [showFillColumnModal, setShowFillColumnModal] = useState(false);
  const [columnFillDraft, setColumnFillDraft] = useState({});
  // Guards auto-initialisation of the visible columns from OCR data so user
  // choices made through the "Add Items" popup are not wiped by later edits.
  const activeFieldsInitializedRef = useRef(false);

  // Only show a data column when at least one line item carries a value for it.
  const shouldShowColumn = (field) =>
    getInvoiceLineItem?.some(
      (item) =>
        item[field] !== null && item[field] !== undefined && item[field] !== "",
    );

  // Default visible grid = the default fields that the OCR/PO data actually
  // filled (matches the pre-existing auto-show behaviour).
  const buildDefaultActiveFields = () =>
    LINE_ITEM_FIELD_OPTIONS.filter((field) => shouldShowColumn(field.key)).map(
      (field) => ({ ...field, isCustom: false }),
    );

  // Keep the active fields in sync with the line items: initialise once the
  // first (OCR) items arrive, and reset when items are cleared (fresh open /
  // cancel) so the next upload re-selects its own columns.
  useEffect(() => {
    const items = getInvoiceLineItem || [];
    if (!items.length) {
      activeFieldsInitializedRef.current = false;
      setActiveGridFields([]);
      return;
    }
    if (activeFieldsInitializedRef.current) return;
    setActiveGridFields(buildDefaultActiveFields());
    activeFieldsInitializedRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getInvoiceLineItem]);

  // Update a single grid cell value (inline editing) on the matching line item.
  const handleGridCellChange = (row, key, value) => {
    const updated = (getInvoiceLineItem || []).map((item) =>
      item.slNo === row.slNo ? { ...item, [key]: value } : item,
    );
    setInvoiceLineItem(updated);
    setInvoiceData((prev) => ({ ...prev, items: updated }));
  };

  // Build the react-data-table column for one active grid field. Every data
  // column is an inline-editable input so values can be typed straight into the
  // line items (including custom fields).
  const fieldColumn = (fieldDef) => ({
    name: fieldDef.label,
    selector: (row) => row?.[fieldDef.key],
    sortable: true,
    width: fieldDef.type === "number" ? "130px" : "180px",
    cell: (row) => (
      <InputField
        type={fieldDef.type}
        className="inputBox mt-1"
        name={fieldDef.key}
        id={`grid-${fieldDef.key}-${row?.slNo ?? "x"}`}
        value={row?.[fieldDef.key] ?? ""}
        onChange={(e) => handleGridCellChange(row, fieldDef.key, e.target.value)}
      />
    ),
  });

  const columns = [
    {
      name: "Sl.No",
      selector: (row) => row.slNo,
      sortable: true,
      width: "80px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.slNo} </p>
        </div>
      ),
    },
    ...activeGridFields.map(fieldColumn),
    {
      name: "Action",
      width: "150px",
      center: true,
      cell: (row) => (
        <div className="d-flex align-items-center justify-content-center">
          <button className="btnTable" onClick={() => openItemEdit(row)}>
            <i className="bi bi-pencil-square mr-1"></i>Edit
          </button>
          <button
            className="btnDelete"
            title="Remove item"
            onClick={() => removeLineItem(row)}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  // ---------------------------------------------------------------------------
  // "Add Items" popup — pick default fields and/or create custom fields that
  // will appear as editable columns on the Invoice Items grid.
  // ---------------------------------------------------------------------------
  const openAddFieldsModal = () => {
    setFieldDraft(activeGridFields.map((f) => ({ ...f })));
    setCustomFieldLabel("");
    setShowAddFieldsModal(true);
  };
  const closeAddFieldsModal = () => {
    setShowAddFieldsModal(false);
    setFieldDraft([]);
    setCustomFieldLabel("");
  };
  const applyFields = () => {
    setActiveGridFields(fieldDraft.map((f) => ({ ...f })));
    closeAddFieldsModal();
  };
  const toggleDefaultField = (field) => {
    setFieldDraft((prev) =>
      prev.some((f) => f.key === field.key)
        ? prev.filter((f) => f.key !== field.key)
        : [...prev, { ...field, isCustom: false }],
    );
  };
  // Custom field keys are a unique slug of the label, so re-adding a removed
  // column with the same label keeps the values previously typed on the rows.
  const makeCustomFieldKey = (label, existing) => {
    let slug = label
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
    if (!slug) slug = "custom";
    let key = slug;
    let n = 1;
    const taken = new Set(existing.map((f) => f.key));
    while (taken.has(key)) key = `${slug}_${n++}`;
    return key;
  };
  const addCustomField = () => {
    const label = customFieldLabel.trim();
    if (!label) {
      toast.error("Enter a custom field name.", { position: "top-right" });
      return;
    }
    setFieldDraft((prev) => [
      ...prev,
      {
        key: makeCustomFieldKey(label, prev),
        label,
        type: "text",
        isCustom: true,
      },
    ]);
    setCustomFieldLabel("");
  };
  const removeDraftField = (key) => {
    setFieldDraft((prev) => prev.filter((f) => f.key !== key));
  };

  // Add a new blank line item to the Invoice Items grid. The currently ticked
  // fields first become grid columns so the blank row can be filled inline.
  const addNewLineItem = () => {
    // If nothing is ticked (e.g. OCR produced no rows yet), fall back to the
    // core fields so the new row is immediately editable.
    const fieldsToApply =
      fieldDraft.length > 0
        ? fieldDraft
        : LINE_ITEM_FIELD_OPTIONS.filter((f) =>
            [
              "itemCode",
              "description",
              "hsnSac",
              "unit",
              "quantity",
              "rate",
              "taxableValue",
              "total",
            ].includes(f.key),
          ).map((f) => ({ ...f, isCustom: false }));
    setActiveGridFields(fieldsToApply.map((f) => ({ ...f })));

    const items = getInvoiceLineItem || [];
    const nextSlNo =
      items.reduce((max, it) => Math.max(max, Number(it?.slNo) || 0), 0) + 1;
    const newRow = { slNo: nextSlNo, isManualItem: true };
    const updated = [...items, newRow];

    setInvoiceLineItem(updated);
    setInvoiceData((prev) => ({ ...prev, items: updated }));
    closeAddFieldsModal();
    toast.success(
      `Line item ${nextSlNo} added — enter its values in the grid.`,
      { position: "top-right" },
    );
  };

  // Remove a line item (manually added or OCR-captured) from the grid.
  const removeLineItem = (row) => {
    const updated = (getInvoiceLineItem || []).filter(
      (item) => item.slNo !== row.slNo,
    );
    setInvoiceLineItem(updated);
    setInvoiceData((prev) => ({ ...prev, items: updated }));
  };

  // ---------------------------------------------------------------------------
  // "Fill Value" popup — pick columns that are already shown on the Invoice
  // Items grid and type one value per column; applying it writes that value to
  // every current (visible) line item in that column at once. Only rows already
  // in the grid are touched; rows added later stay empty until filled again.
  // ---------------------------------------------------------------------------
  const openFillColumnModal = () => {
    if (!getInvoiceLineItem?.length) {
      toast.error("No line items yet — scan/upload an invoice first.", {
        position: "top-right",
      });
      return;
    }
    const draft = {};
    activeGridFields.forEach((f) => (draft[f.key] = ""));
    setColumnFillDraft(draft);
    setShowFillColumnModal(true);
  };
  const closeFillColumnModal = () => {
    setShowFillColumnModal(false);
    setColumnFillDraft({});
  };
  const handleFillFieldChange = (key, value) => {
    setColumnFillDraft((prev) => ({ ...prev, [key]: value }));
  };
  const applyColumnFill = () => {
    const entries = Object.entries(columnFillDraft || {}).filter(
      ([, val]) => val !== undefined && val !== null && String(val).trim() !== "",
    );
    if (!entries.length) {
      toast.error("Enter a value for at least one column.", {
        position: "top-right",
      });
      return;
    }
    const items = getInvoiceLineItem || [];
    if (!items.length) {
      toast.error("No line items to fill.", { position: "top-right" });
      return;
    }
    // Fill only the rows actually shown in the grid (the same filter used by
    // the DataTable); hidden fully-empty OCR rows are left untouched.
    const visibleSlNos = new Set(
      items
        .filter((row) => hasLineItemValues(row) || row?.isManualItem)
        .map((row) => row.slNo),
    );
    if (!visibleSlNos.size) {
      toast.error("No line items in the grid to fill.", {
        position: "top-right",
      });
      return;
    }
    const values = {};
    entries.forEach(([key, val]) => {
      values[key] = String(val).trim();
    });
    const updated = items.map((item) =>
      visibleSlNos.has(item.slNo) ? { ...item, ...values } : item,
    );
    setInvoiceLineItem(updated);
    setInvoiceData((prev) => ({ ...prev, items: updated }));
    closeFillColumnModal();
    toast.success(
      `Filled ${entries.length} column${entries.length > 1 ? "s" : ""} on ${
        visibleSlNos.size
      } line item${visibleSlNos.size > 1 ? "s" : ""}.`,
      { position: "top-right" },
    );
  };

  // Values of custom (user-created) fields on a line item, for the Save payload.
  const activeCustomFieldValues = (row) => {
    if (!row) return {};
    const out = {};
    activeGridFields.forEach((field) => {
      if (!field.isCustom) return;
      const val = row[field.key];
      if (val !== undefined && val !== null && val !== "") out[field.key] = val;
    });
    return out;
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    setParentInfo(props?.invoiceinfo);
    if (props?.viewInvoiceData) {
      setInvoiceData(props?.viewInvoiceData);
      setViewInvoiceDataStatus(true);
    } else {
      setInvoiceData({
        vendorInvoiceNo: "",
        vendorInvoiceDate: "",
        vendorBasicValue: "",
        vendorTotalInvoiceValue: "",
        dispInvoiceStatusHeader: "",
        dispCreatedBy: "",
        dispCreatedByName: "",
        deliveryName: "",
        dispTotalQty: "",
        dispBasicPricePerUnit: "",
        dispBasicPrice: "",
        dispCGST: 0,
        dispSGST: 0,
        dispTransporterCode: "",
        dispTransporterName: "",
        dispVehieleRegNo: "",
        dispCustomerCode: "",
        igst: "",
        supplierGSTIN: "",
        supplierPAN: "",
        supplierPhone: "",
        taxAmountInWords: "",
        items: [],
        dispCompanyBankDetails: [],
        invoiceBillDocument: "",
        purchasingDocumentNr: "",
        purchasingDocumentDate: "",
        purchasingDocumentValue: "",
        currencyCode: "",
        currency: "",
        vendorCode: "",
        vendorName: "",
        paymentTerms: "",
        incoTerms: "",
        companyCodeCode: "",
        purchaseType: "",
        invoiceType: "",
        dispgst: 0,
        purchaseOrderNumber: "",
      });
      setInvoiceLineItem([]);
    }

    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  useEffect(() => {
    const items = invoiceData?.items || [];

    // Only recompute from line items when line items are present.
    // Otherwise keep the OCR-provided values (dispcgst/sgst/totalQty).
    if (!items.length) return;

    // ✅ Calculate total basic amount
    const totalBasicAmount = items.reduce((acc, item) => {
      const amount = parseFloat(item.basicAmount) || 0;
      return acc + amount;
    }, 0);

    // ✅ Calculate GST
    const gst = (totalBasicAmount * 18) / 100;
    const cgst = gst / 2;
    const sgst = gst / 2;

    // ✅ Calculate total order quantity
    const totalQuantity = items.reduce((acc, item) => {
      const qty = parseFloat(item.orderQuantityLoad) || 0;
      return acc + qty;
    }, 0);

    // ✅ Update invoice data (GST)
    setInvoiceData((prev) => ({
      ...prev,
      dispgst: gst.toFixed(2),
      totalOrderQuantity: totalQuantity,
      vendorTaxValue: gst.toFixed(2),
      dispCGST: cgst.toFixed(2),
      dispSGST: sgst.toFixed(2),
    }));

    // ✅ Update total order quantity
    setTotalOrderQuantity(totalQuantity);
  }, [invoiceData?.items]);

  // Keep the Invoice Items table in sync with the current items (upload / view / edit)
  useEffect(() => {
    setInvoiceLineItem(invoiceData?.items || []);
  }, [invoiceData?.items]);

  const handleFileChange = (event) => {
    // const selectedFile = event.target.files[0];
    setFile(event.target.files[0]);
  };

  const selectFile = () => {
    fileInputRef?.current?.click();
  };
  const cancelInvoice = () => {
    // Bump the token so any in-flight uploadInvoice response is discarded
    uploadTokenRef.current += 1;
    setUploadStatus(false);
    setFile(null);
  };

  const uploadInvoice = async () => {
    // Capture the current token; the response is ignored if the user cancels first
    const uploadToken = uploadTokenRef.current;
    setUploadStatus(true);
    if (file) {
      // Create FormData and append the file
      const formData = new FormData();
      formData.append("file", file);
      formData.append("module", "Invoice");
      formData.append("filePath", "invoice");

      await ItemService.uploadInvoiceOCR(formData).then(async (item) => {
        // If cancelInvoice was clicked while this request was in flight, stop here
        if (uploadToken !== uploadTokenRef.current) return;
        // Graceful handling: an OCR failure (e.g. HTTP 429 AI rate limit) resolves
        // as { status, message } with no data — show the server message and stop
        // instead of silently populating an empty invoice.
        if (!item?.data) {
          toast.error(
            item?.message || "Invoice OCR upload failed. Please try again.",
            { position: "top-right" },
          );
          setUploadStatus(false);
          return;
        }
        const ocrData = item?.data || {};
        const ocrItems =
          ocrData?.lineItems?.map((line, index) => ({
            ...line,
            slNo: index + 1,
          })) || [];

        // The uploaded OCR file also becomes the Invoice Bill Document.
        // Prefer the attachmentId returned by OCR; otherwise upload the same
        // file through the attachment uploader (uploadFiles) to get one.
        let attachmentId = ocrData?.attachmentId;
        if (!attachmentId && file) {
          try {
            const attachForm = new FormData();
            attachForm.append("files", file);
            const up = await ItemService.uploadFiles(attachForm);
            attachmentId = up?.attachmentId;
          } catch (err) {
            console.error("Invoice bill attachment upload failed:", err);
          }
        }

        setOcrInvoiceData({
          vendorInvoiceNo: ocrData?.invoiceNumber,
          vendorInvoiceDate: ocrData?.invoiceDate,
          vendorBasicValue: ocrData?.subtotal,
          vendorTotalInvoiceValue: ocrData?.grandTotal,
          dispInvoiceStatusHeader: ocrData?.invoiceStatusHeader,
          dispCreatedBy: ocrData?.createdBy,
          dispCreatedByName: ocrData?.createdByName,
          deliveryName: ocrData?.description,
          dispTotalQty:
            ocrData?.totalQty ||
            ocrItems?.reduce(
              (acc, line) => acc + (parseFloat(line?.quantity) || 0),
              0,
            ),
          dispBasicPricePerUnit: ocrData?.basicPricePerUnit,
          dispBasicPrice: ocrData?.subtotal,

          dispCGST: ocrData?.cgst,
          dispSGST: ocrData?.sgst,

          dispTransporterCode: ocrData?.transporterCode,
          dispTransporterName: ocrData?.transporterName,
          dispVehieleRegNo: ocrData?.vehicleNumber,
          dispCustomerCode: ocrData?.customerCode,
          igst: ocrData?.igst,
          supplierGSTIN: ocrData?.supplierGSTIN,
          supplierPAN: ocrData?.supplierPAN,
          supplierName: ocrData?.supplierName,
          supplierPhone: ocrData?.supplierPhone,
          taxAmountInWords: ocrData?.taxAmountInWords,
          vendorName: ocrData?.supplierName,
          items: ocrItems,
          dispCompanyBankDetails: ocrData?.companyBankDetails,
          invoiceBillDocument: attachmentId || "",
          attachmentId: attachmentId || "",

          purchaseOrderNumber: ocrData?.purchaseOrderNumber || "",
          purchasingDocumentNr:
            ocrData?.purchaseOrderNumber || getHeaderData?.purchasingDocumentNr,
          purchasingDocumentDate: getHeaderData?.purchasingDocumentDate,
          purchasingDocumentValue: getHeaderData?.purchasingDocumentValue,

          currencyCode: getHeaderData?.currencyCode,
          currency: getHeaderData?.currency,

          vendorCode: getHeaderData?.vendorCode,
          supplierCode: ocrData?.supplierCode || ocrData?.vendorCode,
          paymentTerms: getHeaderData?.paymentTerms,
          incoTerms: getHeaderData?.incoTerms,
          companyCodeCode: getHeaderData?.companyCodeCode,
          purchaseType: getHeaderData?.purchaseType,

          invoiceType: "OCR",
        });
        // Fresh OCR data arrived — let the active grid columns be re-derived
        // from this upload's line items.
        activeFieldsInitializedRef.current = false;
        setInvoiceLineItem(ocrItems);
        setInvoiceData({
          vendorInvoiceNo: ocrData?.invoiceNumber,
          vendorInvoiceDate: ocrData?.invoiceDate,
          vendorBasicValue: ocrData?.subtotal,
          vendorTotalInvoiceValue: ocrData?.grandTotal,
          dispInvoiceStatusHeader: ocrData?.invoiceStatusHeader,
          dispCreatedBy: ocrData?.createdBy,
          dispCreatedByName: ocrData?.createdByName,
          deliveryName: ocrData?.description,
          dispTotalQty:
            ocrData?.totalQty ||
            ocrItems?.reduce(
              (acc, line) => acc + (parseFloat(line?.quantity) || 0),
              0,
            ),
          dispBasicPricePerUnit: ocrData?.basicPricePerUnit,
          dispBasicPrice: ocrData?.subtotal,

          dispCGST: ocrData?.cgst,
          dispSGST: ocrData?.sgst,

          dispTransporterCode: ocrData?.transporterCode,
          dispTransporterName: ocrData?.transporterName,
          dispVehieleRegNo: ocrData?.vehicleNumber,
          dispCustomerCode: ocrData?.customerCode,
          igst: ocrData?.igst,
          supplierGSTIN: ocrData?.supplierGSTIN,
          supplierPAN: ocrData?.supplierPAN,
          supplierName: ocrData?.supplierName,
          supplierPhone: ocrData?.supplierPhone,
          taxAmountInWords: ocrData?.taxAmountInWords,
          vendorName: ocrData?.supplierName,
          items: ocrItems,
          dispCompanyBankDetails: ocrData?.companyBankDetails,
          invoiceBillDocument: attachmentId || "",
          attachmentId: attachmentId || "",

          purchaseOrderNumber: ocrData?.purchaseOrderNumber || "",
          purchasingDocumentNr:
            ocrData?.purchaseOrderNumber || getHeaderData?.purchasingDocumentNr,
          purchasingDocumentDate: getHeaderData?.purchasingDocumentDate,
          purchasingDocumentValue: getHeaderData?.purchasingDocumentValue,

          currencyCode: getHeaderData?.currencyCode,
          currency: getHeaderData?.currency,

          vendorCode: getHeaderData?.vendorCode,
          supplierCode: ocrData?.supplierCode || ocrData?.vendorCode,
          paymentTerms: getHeaderData?.paymentTerms,
          incoTerms: getHeaderData?.incoTerms,
          companyCodeCode: getHeaderData?.companyCodeCode,
          purchaseType: getHeaderData?.purchaseType,

          invoiceType: "OCR",
        });
        setFile(null);
      });
      setUploadStatus(false);
    } else {
      // alert('Please select a file first.');
    }
  };

  //handle cancel modal
  const handleCancel = () => {
    // Cancel any in-flight upload so its response is discarded (same as cancelInvoice)
    uploadTokenRef.current += 1;
    setUploadStatus(false);
    setOcrInvoiceData({});
    setInvoiceData({});
    setParentInfo();
    setInvoiceData();
    setViewInvoiceDataStatus();
    setInvoiceLineItem();
    props.onHide();
  };

  useEffect(() => {
    if (!getShowSuccessModal && wasModalShown) {
      props.onHide(); // Call only when modal transitions from true → false
      setWasModalShown(false); // Reset tracker
    }
  }, [getShowSuccessModal, wasModalShown, props]);
  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
    setWasModalShown(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  // Compare the OCR invoice against the PO (props.viewInvoiceData) before
  // saving. PO number, Supplier Code and Total Amount must match the PO; if any
  // is missing or mismatched the invoice cannot be created. props.viewInvoiceData
  // is the authoritative PO the parent passes in, so this never depends on
  // state that may be stale/empty on reopen.
  const validateInvoiceAgainstPO = async (poOverride, invOverride) => {
    // PO source: props.viewInvoiceData (authoritative), else the loaded header.
    // Accept an already-resolved PO/invoice when the caller has them (handleSave)
    // to avoid re-fetching the PO detail.
    let po = poOverride || props?.viewInvoiceData;
    if (!po) {
      const loaded = await loadInitialPageData();
      po = loaded || getHeaderData;
    }
    if (!po) return ["PO data is not loaded. Cannot create invoice."];
    // Invoice source: the OCR-extracted invoice (kept in ocrInvoiceData, and
    // mirrored into invoiceData.items) — compare its values against the PO.
    const inv =
      invOverride ||
      (ocrInvoiceData && Object.keys(ocrInvoiceData).length
        ? ocrInvoiceData
        : invoiceData);
    const errors = [];

    // 1. Supplier Code — compulsory and must match the PO vendor
    const invSupplier = String(
      inv?.supplierCode || inv?.vendorCode || "",
    ).trim();
    const poSupplier = String(po?.vendorCode || "").trim();
    if (!invSupplier) {
      errors.push("Supplier Code is required on the invoice.");
    } else if (!poSupplier) {
      errors.push("Supplier Code is missing on the PO.");
    } else if (invSupplier !== poSupplier) {
      errors.push(
        `Supplier Code mismatch: invoice "${invSupplier}" vs PO "${poSupplier}"`,
      );
    }

    // 2. PO Code — compulsory and must match the PO number. The OCR-extracted
    // invoice number may carry a version/revision tag (e.g. "PO0139 (V0)")
    // that the PO number itself does not. Strip such a trailing "(V#)" tag
    // before comparing so the two are treated as the same PO; the original
    // values are kept for the error message.
    const stripPoVersion = (nr) =>
      String(nr || "").trim().replace(/\s*\(V\d+\)\s*$/i, "");
    const invPoNr = String(
      inv?.purchaseOrderNumber || inv?.purchasingDocumentNr || "",
    ).trim();
    const poNr = String(
      po?.purchasingDocumentNr ||
        props?.invoiceinfo?.purchasingDocumentNr ||
        "",
    ).trim();
    if (!invPoNr) {
      errors.push("PO Code is required on the invoice.");
    } else if (!poNr) {
      errors.push("PO Code is missing on the PO.");
    } else if (stripPoVersion(invPoNr) !== stripPoVersion(poNr)) {
      errors.push(`PO Code mismatch: invoice "${invPoNr}" vs PO "${poNr}"`);
    }

    // 3. Total Amount — the OCR invoice total must match the PO total
    const invTotal =
      Number(
        inv?.vendorTotalInvoiceValue ??
          inv?.grandTotal ??
          inv?.purchasingDocumentValue,
      ) || 0;
    const poTotal = Number(po?.purchasingDocumentValue || po?.grandTotal) || 0;
    if (!invTotal) {
      errors.push("Total amount is required on the invoice.");
    } else if (!poTotal) {
      errors.push("Total amount is missing on the PO.");
    } else if (Math.abs(invTotal - poTotal) > 0.01) {
      errors.push(
        `Total amount mismatch: invoice "${invTotal}" vs PO "${poTotal}"`,
      );
    }

    // 4. Number of Items — the invoice line count must match the PO line count
    const invItemCount = (inv?.items || []).length;
    const poItemCount = (po?.items || []).length;
    if (!invItemCount) {
      errors.push("No line items found on the invoice.");
    } else if (!poItemCount) {
      errors.push("No line items found on the PO.");
    } else if (invItemCount !== poItemCount) {
      errors.push(
        `Number of items mismatch: invoice has "${invItemCount}" vs PO has "${poItemCount}"`,
      );
    }

    return errors;
  };

  // A line item is meaningful if it carries any of the known OCR / PO line
  // fields. Fully-empty OCR rows (blank second line etc.) are dropped from the
  // GRN payload and from validation, matching what the invoice table shows.
  // Manually added rows (isManualItem) are always kept so a blank row the user
  // added is validated and prompts them to fill or remove it before saving.
  const hasAnyLineItemValues = (row) =>
    row?.isManualItem === true ||
    [
      row?.itemCode,
      row?.materialCode,
      row?.description,
      row?.materialDescription,
      row?.hsnSac,
      row?.quantity,
      row?.purchaseQuantity,
      row?.grnQuantity,
      row?.rate,
      row?.orderPriceUnit,
      row?.unitPrice,
      row?.taxableValue,
      row?.total,
      row?.netValue,
    ].some((v) => v !== null && v !== undefined && v !== "");

  // Current editable invoice: the original OCR snapshot overlaid with every
  // user edit made in the UI. Header edits write to invoiceData and line-item
  // edits write to getInvoiceLineItem, so this is what validation and the GRN
  // payload must read — never the untouched ocrInvoiceData snapshot.
  const buildCurrentInvoice = () => {
    const snapshot =
      ocrInvoiceData && Object.keys(ocrInvoiceData).length
        ? { ...ocrInvoiceData, ...invoiceData }
        : invoiceData;
    const rawItems =
      getInvoiceLineItem?.length > 0
        ? getInvoiceLineItem
        : snapshot?.items || [];
    return {
      ...snapshot,
      items: rawItems.filter(hasAnyLineItemValues),
    };
  };

  // Validate a single line item. Returns a list of human-readable errors.
  const validateLineItem = (item, line) => {
    const errors = [];
    const itemCode = String(item?.itemCode || item?.materialCode || "").trim();
    const description = String(
      item?.description || item?.materialDescription || "",
    ).trim();
    if (!itemCode && !description) {
      errors.push(`Line ${line}: Item Code or Description is required.`);
    }

    const qty = Number(
      item?.quantity ??
        item?.purchaseQuantity ??
        item?.grnQuantity ??
        item?.invoiceQuantity,
    );
    if (!Number.isFinite(qty) || qty <= 0) {
      errors.push(`Line ${line}: Quantity must be a number greater than zero.`);
    }

    const rate = Number(item?.rate ?? item?.orderPriceUnit ?? item?.unitPrice);
    if (!Number.isFinite(rate) || rate < 0) {
      errors.push(`Line ${line}: Rate must be a valid non-negative number.`);
    }

    // Every amount column (taxes, discount, totals) must be a valid
    // non-negative number when present. Includes the OCR aliases gst/gstAmount
    // and tax/taxAmount that the invoice table may expose.
    const numericFields = [
      ["taxableValue", "Taxable Value"],
      ["cgstAmount", "CGST Amount"],
      ["sgstAmount", "SGST Amount"],
      ["igstAmount", "IGST Amount"],
      ["gst", "GST"],
      ["gstAmount", "GST Amount"],
      ["tax", "Tax"],
      ["taxAmount", "Tax Amount"],
      ["discount", "Discount"],
      ["cess", "Cess"],
      ["total", "Total"],
      ["netValue", "Net Value"],
      ["totalPrice", "Total Price"],
    ];
    numericFields.forEach(([field, label]) => {
      const val = item?.[field];
      if (val === null || val === undefined || val === "") return;
      const num = Number(val);
      if (Number.isNaN(num)) {
        errors.push(`Line ${line}: ${label} must be a valid number.`);
      } else if (num < 0) {
        errors.push(`Line ${line}: ${label} cannot be negative.`);
      }
    });

    // A tax % without its matching amount is a data gap the user must fill.
    if (item?.cgstPercent != null && String(item?.cgstPercent).trim() !== "") {
      const cgst = Number(item?.cgstAmount);
      if (!Number.isFinite(cgst) || cgst <= 0) {
        errors.push(`Line ${line}: CGST Amount is required when CGST % is set.`);
      }
    }
    if (item?.sgstPercent != null && String(item?.sgstPercent).trim() !== "") {
      const sgst = Number(item?.sgstAmount);
      if (!Number.isFinite(sgst) || sgst <= 0) {
        errors.push(`Line ${line}: SGST Amount is required when SGST % is set.`);
      }
    }
    if (item?.igstPercent != null && String(item?.igstPercent).trim() !== "") {
      const igst = Number(item?.igstAmount);
      if (!Number.isFinite(igst) || igst <= 0) {
        errors.push(`Line ${line}: IGST Amount is required when IGST % is set.`);
      }
    }

    // Cross-check the line total against Taxable + Taxes (CGST + SGST + IGST),
    // but only when every side is present so OCR rounding / missing columns do
    // not produce false positives.
    const taxable = Number(item?.taxableValue);
    const cgst = Number(item?.cgstAmount);
    const sgst = Number(item?.sgstAmount);
    const igst = Number(item?.igstAmount);
    const total = Number(item?.total ?? item?.netValue ?? item?.totalPrice);
    const isPosNum = (n) => Number.isFinite(n) && n > 0;
    if (
      isPosNum(total) &&
      (isPosNum(taxable) || isPosNum(cgst) || isPosNum(sgst) || isPosNum(igst))
    ) {
      const taxSum = [cgst, sgst, igst]
        .filter((n) => Number.isFinite(n))
        .reduce((a, b) => a + b, 0);
      const expected = (isPosNum(taxable) ? taxable : 0) + taxSum;
      if (isPosNum(expected) && Math.abs(expected - total) > 0.5) {
        errors.push(
          `Line ${line}: Total (${total}) does not match Taxable + Taxes (${expected.toFixed(
            2,
          )}).`,
        );
      }
    }

    return errors;
  };

  // Validate every OCR-captured header field and line item before the Add GRN
  // API is called. Returns a list of human-readable errors (empty = valid).
  // Runs against the current editable invoice so a user correction to a
  // mis-OCR'd field is what actually gets validated.
  const validateGRNInputs = (inv) => {
    const errors = [];

    // --- Header fields ---
    // Each entry: [primary field, label, alternate field]. The alternate is
    // used when the OCR field is empty but the value is available from the PO
    // context (e.g. purchasingDocumentNr / vendorCode).
    const requiredHeader = [
      ["purchaseOrderNumber", "Purchase Order Number", "purchasingDocumentNr"],
      ["supplierCode", "Supplier Code", "vendorCode"],
      ["vendorInvoiceNo", "Invoice Number"],
      ["vendorInvoiceDate", "Invoice Date"],
    ];
    requiredHeader.forEach(([field, label, alt]) => {
      const val = String(inv?.[field] ?? inv?.[alt] ?? "").trim();
      if (!val) errors.push(`${label} is required.`);
    });

    // Numeric header values must be valid non-negative numbers when present
    const numericHeader = [
      ["vendorBasicValue", "Basic Price"],
      ["vendorTotalInvoiceValue", "Total Amount"],
      ["dispCGST", "CGST"],
      ["dispSGST", "SGST"],
      ["igst", "IGST"],
    ];
    numericHeader.forEach(([field, label]) => {
      const val = inv?.[field];
      if (val === null || val === undefined || val === "") return;
      const num = Number(val);
      if (Number.isNaN(num)) {
        errors.push(`${label} must be a valid number.`);
      } else if (num < 0) {
        errors.push(`${label} cannot be negative.`);
      }
    });

    // --- Line items ---
    const items = inv?.items || [];
    if (!items.length) {
      errors.push("No line items found on the invoice.");
      return errors;
    }
    items.forEach((item, index) => {
      const line = item?.lineNo || item?.slNo || index + 1;
      validateLineItem(item, line).forEach((err) => errors.push(err));
    });

    return errors;
  };

    // const handleSave = async () => {
    //   if (!items.length) {
    //     toast.error("No line items found for GRN creation!", {
    //       duration: 4000,
    //       position: "top-right",
    //     });
    //     return;
    //   }

    //   const toastId = toast.loading("Creating GRN...", {
    //     position: "top-right",
    //   });
    //   try {
    //     setDisabled(true);
    //     // Build GRN payload directly from OCR/Invoice data + PO data
    //     const invNo = inv.vendorInvoiceNo || ocrInvoiceData?.vendorInvoiceNo || "";
    //     const grnDate = new Date().toISOString().split("T")[0];
    //     // Remove unused buildInvoicePayload reference
    //     const grnPayload = {
    //       data: {
    //         subTransactionActivity: "PO", // GRN from PO
    //         documentType: "GRN",
    //         transactionActivity: "GRN",
    //         purchasingDocumentNr:
    //           po.purchasingDocumentNr ||
    //           inv.purchasingDocumentNr ||
    //           parentInfo?.purchasingDocumentNr,
    //         purchasingDocumentDate:
    //           po.purchasingDocumentDate || inv.purchasingDocumentDate,
    //         grnStatusHeader: "Created",
    //         grnDate: grnDate,
    //         despatchNr: "",
    //         despatchDate: "",
    //         vendorCode: po.vendorCode || inv.vendorCode,
    //         vendorName: po.vendorName || inv.vendorName,
    //         shippingType: "",
    //         grnRemark: invNo ? `GRN created from Invoice: ${invNo}` : "GRN created from Invoice Upload",
    //         grnCount: "1",
    //         purchasingDocumentValue:
    //           po.purchasingDocumentValue || inv.purchasingDocumentValue,
    //         deliveredValue: po.deliveredValue || "",
    //         deliveredStatus: po.deliveredStatus || "",
    //         invoicedValue: po.invoicedValue || "",
    //         invoicedStatus: po.invoicedStatus || "",
    //         paidValue: po.paidValue || "",
    //         currency: po.currency || inv.currency,
    //         currencyCode: po.currencyCode || inv.currencyCode || "INR",
    //         paymentTerms: po.paymentTerms || inv.paymentTerms,
    //         deliveryNoteNr: inv.vendorInvoiceNo || "",
    //         billOfLading: "",
    //         incoTerms: po.incoTerms || inv.incoTerms,
    //         vendorInvoiceNo: inv.vendorInvoiceNo || "",
    //         vendorInvoiceDate: inv.vendorInvoiceDate || "",
    //         vendorBasicValue:
    //           po.purchasingDocumentItemTotalValue ?? inv.vendorBasicValue ?? 0,
    //         vendorTaxValue:
    //           po.purchasingDocumentTaxTotalValue ?? inv.vendorTaxValue ?? 0,
    //         vendorOtherChargesValue: inv.vendorOtherChargesValue ?? 0,
    //         vendorTotalInvoiceValue:
    //           po.purchasingDocumentValue ?? inv.vendorTotalInvoiceValue ?? 0,
    //         vendorInvoiceCurrency: po.currencyCode || inv.currencyCode || "INR",
    //         items: items.map((it, index) => ({
    //           grnItemNr: index + 1,
    //           materialCode: it.materialCode || it.itemCode || "",
    //           materialDescription:
    //             it.materialDescription || it.description || it.materialLongText || "",
    //           purchaseQuantity:
    //             it.purchaseQuantity ?? it.quantity ?? 0,
    //           grnQuantity:
    //             it.invoiceQuantity ?? it.purchaseQuantity ?? it.quantity ?? 0,
    //           grnBalancePurchaseQuantity:
    //             it.invBalancePurchaseQuantity ??
    //             it.purchaseQuantity ??
    //             it.quantity ??
    //             0,
    //           currency: it.currencyCode || po.currencyCode || "INR",
    //           orderUnitOfMeasure: it.orderUnitOfMeasure || it.unit || "",
    //           grnStatusItem: "New",
    //           supplierBatchNumber: "",
    //           plant: "",
    //           storeLocation: "",
    //           purchasingDocumentNr:
    //             po.purchasingDocumentNr || inv.purchasingDocumentNr,
    //           purchasingDocumentItemNr: it.purchasingDocumentItemNr || it.lineNo,
    //           grossWeight: "",
    //           grnDeletionIndicator: "",
    //           cancellationRemarks: "",
    //           cancelledBy: "",
    //           cancelledOn: "",
    //           cancelledTime: "",
    //         })),
    //       },
    //     };

    //     // Create GRN directly (no invoice creation)
    //     const grnResult = await ItemService.addGRN(grnPayload);

    //     if (grnResult?.status === 200) {
    //       modalData.successMsg = grnResult?.message || "GRN created successfully!";
    //       setModalInfo(modalData);
    //       onSuccessfullyRegistered();
    //       setWasModalShown(true);

    //       dispatch(getGoodsReceivedNote());
    //       toast.success(grnResult?.message || "GRN created successfully!", {
    //         duration: 4000,
    //         position: "top-right",
    //       });

    //       if (props.onsuccessdata) {
    //         props.onsuccessdata({
    //           grn: grnResult,
    //           grnPayload,
    //           invoiceNumber: invNo,
    //         });
    //       }
    //     } else {
    //       toast.error(grnResult?.message || "GRN creation failed!", {
    //         duration: 6000,
    //         position: "top-right",
    //       });
    //     }
    //   } catch (error) {
    //     console.error("Error while creating GRN:", error);
    //     toast.error("Something went wrong!", {
    //       duration: 4000,
    //       position: "top-right",
    //     });
    //   } finally {
    //     toast.dismiss(toastId);
    //     setDisabled(false);
    //   }
    // };

  // Handle edits to the "Uploaded Invoice details" block
   const handleSave = async () => {
    // 1. Resolve PO data
    let po = props?.viewInvoiceData;
    if (!po) {
      const loaded = await loadInitialPageData();
      po = loaded || getHeaderData;
    }

    // 2. Resolve the current editable invoice (OCR snapshot + user edits)
    const inv = buildCurrentInvoice();

    // 3. Resolve items
    const items = inv?.items || [];

    if (!items.length) {
      toast.error("No line items found for GRN creation!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    // Validate every OCR-captured header field and line item before creating
    // the GRN. Only if these pass do we call the Add GRN API.
    const vErrors = validateGRNInputs(inv);
    if (vErrors.length) {
      toast.error(vErrors.join(" | "), {
        duration: 6000,
        position: "top-right",
      });
      return;
    }

    // Then verify the (now corrected) invoice matches the PO: PO number,
    // supplier code, number of items and total value.
    const poErrors = await validateInvoiceAgainstPO(po, inv);
    if (poErrors.length) {
      toast.error(poErrors.join(" | "), {
        duration: 6000,
        position: "top-right",
      });
      return;
    }

    const toastId = toast.loading("Creating GRN...", {
      position: "top-right",
    });

    try {
      setDisabled(true);

      // Build GRN payload directly from OCR/Invoice data + PO data
      const invNo = inv.vendorInvoiceNo || ocrInvoiceData?.vendorInvoiceNo || "";
      const grnDate = new Date().toISOString().split("T")[0];

      // Build a lookup of PO line items so every GRN line can carry the full
      // set of PO fields (orderPriceUnit, taxCode, netValue, deliveryDate,
      // taxAmount, taxIdDesc, purchaseReqNr, purchaseReqitemNr,
      // excessTolerance, shortageTolerance, currencyCode, ...) that
      // CreateInvoice expects when it reads the GRN back. Matches the invoice
      // line to the PO line by PO item number first, then by material code.
      const poItems = po?.items || [];
      const poItemByLineNr = {};
      const poItemByMaterial = {};
      poItems.forEach((poItem) => {
        const lineNr = String(
          poItem?.purchasingDocumentItemNr ?? poItem?.lineNo ?? ""
        ).trim();
        if (lineNr) poItemByLineNr[lineNr] = poItem;
        const matCode = String(
          poItem?.materialCode ?? poItem?.itemCode ?? ""
        ).trim();
        if (matCode) poItemByMaterial[matCode] = poItem;
      });

      const grnPayload = {
        data: {
          subTransactionActivity: "PO", // GRN from PO
          documentType: "GRN",
          transactionActivity: "GRN",
          purchasingDocumentNr:
            po?.purchasingDocumentNr ||
            inv?.purchasingDocumentNr ||
            parentInfo?.purchasingDocumentNr,
          purchasingDocumentDate:
            po?.purchasingDocumentDate || inv?.purchasingDocumentDate,
          grnStatusHeader: "Created",
          grnDate: grnDate,
          despatchNr: "",
          despatchDate: "",
          vendorCode: po?.vendorCode || inv?.vendorCode,
          vendorName: po?.vendorName || inv?.vendorName,
          shippingType: "",
          grnRemark: invNo ? `GRN created from Invoice: ${invNo}` : "GRN created from Invoice Upload",
          grnCount: "1",
          purchasingDocumentValue:
            po?.purchasingDocumentValue || inv?.purchasingDocumentValue,
          deliveredValue: po?.deliveredValue || "",
          deliveredStatus: po?.deliveredStatus || "",
          invoicedValue: po?.invoicedValue || "",
          invoicedStatus: po?.invoicedStatus || "",
          paidValue: po?.paidValue || "",
          currency: po?.currency || inv?.currency,
          currencyCode: po?.currencyCode || inv?.currencyCode || "INR",
          paymentTerms: po?.paymentTerms || inv?.paymentTerms,
          deliveryNoteNr: inv?.vendorInvoiceNo || "",
          billOfLading: "",
          incoTerms: po?.incoTerms || inv?.incoTerms,
          vendorInvoiceNo: inv?.vendorInvoiceNo || "",
          vendorInvoiceDate: inv?.vendorInvoiceDate || "",
          vendorBasicValue:
            po?.purchasingDocumentItemTotalValue ?? inv?.vendorBasicValue ?? 0,
          vendorTaxValue:
            po?.purchasingDocumentTaxTotalValue ?? inv?.vendorTaxValue ?? 0,
          vendorOtherChargesValue: inv?.vendorOtherChargesValue ?? 0,
          vendorTotalInvoiceValue:
            po?.purchasingDocumentValue ?? inv?.vendorTotalInvoiceValue ?? 0,
          vendorInvoiceCurrency: po?.currencyCode || inv?.currencyCode || "INR",
          // Carry the uploaded/OCR invoice file on the GRN header so the
          // Create-Invoice page can re-use it (invoice file auto-fill).
          invoiceBillDocument:
            inv?.invoiceBillDocument || inv?.attachmentId || "",
          attachmentId: inv?.attachmentId || inv?.invoiceBillDocument || "",
          // Header-level values the Create-Invoice page reads back to fill the
          // Invoice Header / Pricing Summary / Invoice details blocks.
          invoiceValue:
            po?.purchasingDocumentItemTotalValue ?? inv?.vendorBasicValue ?? 0,
          subTotalValue:
            po?.purchasingDocumentItemTotalValue ?? inv?.vendorBasicValue ?? 0,
          getInvTaxTotalValue:
            po?.purchasingDocumentTaxTotalValue ?? inv?.vendorTaxValue ?? 0,
          getOtherChargesValue:
            inv?.vendorOtherChargesValue ??
            po?.purchasingDocumentOtherChargesValue ??
            0,
          vendorFreightValue: inv?.vendorFreightValue ?? 0,
          items: items.map((it, index) => {
            // Match this invoice/OCR line to its PO line so no PO field is
            // lost when the GRN is created (CreateInvoice reads these back).
            // OCR can expose the identifiers under several aliases, so check
            // them all before giving up.
            const lineNrKey = String(
              it?.purchasingDocumentItemNr ??
                it?.lineNo ??
                it?.lineItemNumber ??
                it?.itemNumber ??
                ""
            ).trim();
            const matCodeKey = String(
              it?.materialCode ??
                it?.itemCode ??
                it?.productCode ??
                it?.partNumber ??
                it?.materialNumber ??
                it?.materialDescription ??
                ""
            ).trim();
            const poItem =
              poItemByLineNr[lineNrKey] || poItemByMaterial[matCodeKey] || {};

            const materialCode =
              it.materialCode || it.itemCode || poItem?.materialCode || poItem?.itemCode || "";
            const materialDescription =
              it.materialDescription ||
              it.description ||
              it.materialLongText ||
              poItem?.materialDescription ||
              "";
            const purchaseQuantity =
              poItem?.purchaseQuantity ?? it.purchaseQuantity ?? it.quantity ?? 0;
            const grnQuantity =
              it.invoiceQuantity ?? it.purchaseQuantity ?? it.quantity ?? poItem?.grnQuantity ?? 0;
            const grnBalancePurchaseQuantity =
              it.invBalancePurchaseQuantity ??
              (Number(purchaseQuantity) - Number(grnQuantity)).toFixed(2);

            // Unit price: OCR exposes it as unitPrice/rate; the PO line as
            // orderPriceUnit. Prefer the OCR value, fall back to the PO.
            const unitPrice = Number(
              it?.orderPriceUnit ?? it?.unitPrice ?? it?.rate ?? poItem?.orderPriceUnit ?? 0
            );
            const netValue =
              it?.netValue ?? it?.total ?? (unitPrice * Number(grnQuantity)).toFixed(2);

            return {
              // Carry all PO line-item fields first, then let the explicit
              // keys below win. This keeps orderPriceUnit, taxCode, netValue,
              // deliveryDate, taxAmount, taxIdDesc, purchaseReqNr,
              // purchaseReqitemNr, excessTolerance, shortageTolerance,
              // currencyCode, invBalancePurchaseQuantity, etc. on the GRN.
              ...poItem,
              grnItemNr: index + 1,
              materialCode,
              materialDescription,
              purchaseQuantity,
              grnQuantity,
              grnBalancePurchaseQuantity,
              invBalancePurchaseQuantity: grnBalancePurchaseQuantity,
              // Explicit price / tax / tolerance fields the Create-Invoice
              // table renders - always sent so the invoice page needs no
              // manual entry.
              orderPriceUnit: unitPrice,
              unitPrice,
              netValue,
              taxCode: it?.taxCode ?? poItem?.taxCode ?? 0,
              taxAmount: it?.taxAmount ?? poItem?.taxAmount ?? 0,
              deliveryDate: poItem?.deliveryDate ?? it?.deliveryDate ?? "",
              taxIdDesc: poItem?.taxIdDesc ?? it?.taxIdDesc ?? "",
              purchaseReqNr: poItem?.purchaseReqNr ?? "",
              purchaseReqitemNr: poItem?.purchaseReqitemNr ?? "",
              excessTolerance: poItem?.excessTolerance ?? "",
              shortageTolerance: poItem?.shortageTolerance ?? "",
              currency:
                it.currencyCode || poItem?.currencyCode || po?.currencyCode || "INR",
              currencyCode:
                it.currencyCode || poItem?.currencyCode || po?.currencyCode || "INR",
              orderUnitOfMeasure:
                it.orderUnitOfMeasure || it.unit || poItem?.orderUnitOfMeasure || "",
              grnStatusItem: "New",
              supplierBatchNumber: poItem?.supplierBatchNumber || "",
              plant: poItem?.plant || "",
              storeLocation: poItem?.storeLocation || "",
              purchasingDocumentNr:
                po?.purchasingDocumentNr || inv?.purchasingDocumentNr,
              purchasingDocumentItemNr:
                it.purchasingDocumentItemNr || it.lineNo || poItem?.purchasingDocumentItemNr,
              grossWeight: poItem?.grossWeight || "",
              grnDeletionIndicator: "",
              cancellationRemarks: "",
              cancelledBy: "",
              cancelledOn: "",
              cancelledTime: "",
              // Carry values of user-created custom columns on this line item.
              ...(activeCustomFieldValues(it) || {}),
            };
          }),
        },
      };

      // Create GRN directly
      const grnResult = await ItemService.addGRN(grnPayload);

      if (grnResult?.status === 200) {
        modalData.successMsg = grnResult?.message || "GRN created successfully!";
        setModalInfo(modalData);
        onSuccessfullyRegistered();
        setWasModalShown(true);

        dispatch(getGoodsReceivedNote());
        toast.success(grnResult?.message || "GRN created successfully!", {
          duration: 4000,
          position: "top-right",
        });

        if (props.onsuccessdata) {
          props.onsuccessdata({
            grn: grnResult,
            grnPayload,
            invoiceNumber: invNo,
          });
        }
      } else {
        toast.error(grnResult?.message || "GRN creation failed!", {
          duration: 6000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error while creating GRN:", error);
      toast.error("Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
      setDisabled(false);
    }
  };
  const handleInvoiceFieldChange = (e) => {
    const { name, value } = e.target;
    if (!name) return;
    setInvoiceData((prev) => ({ ...prev, [name]: value }));
  };

  // Open line-item edit popup. Ensure all expected keys exist on the item
  // (null defaults) so they are never dropped from the payload; the popup
  // only renders an input for keys that actually carry a value.
  const ITEM_EDIT_DEFAULTS = {
    lineNo: null,
    itemCode: null,
    description: null,
    hsnSac: null,
    quantity: null,
    unit: null,
    rate: null,
    discount: null,
    taxableValue: null,
    cgstPercent: null,
    cgstAmount: null,
    sgstPercent: null,
    sgstAmount: null,
    igstPercent: null,
    igstAmount: null,
    cess: null,
    total: null,
  };
  const openItemEdit = (row) => {
    setEditingItem({ ...ITEM_EDIT_DEFAULTS, ...row });
    setShowItemModal(true);
  };
  const closeItemEdit = () => {
    setShowItemModal(false);
    setEditingItem(null);
  };
  const handleItemFieldChange = (e) => {
    const { name, value } = e.target;
    if (!name) return;
    setEditingItem((prev) => ({ ...prev, [name]: value }));
  };

  // Apply a line-item edit to internal state + persist via updatePOFields
  const commitItemEdit = async () => {
    if (!editingItem) return;

    // Validate the edited line item before applying / persisting it.
    const itemErrors = validateLineItem(
      editingItem,
      editingItem?.lineNo || editingItem?.slNo || 1,
    );
    if (itemErrors.length) {
      toast.error(itemErrors.join(" | "), {
        duration: 6000,
        position: "top-right",
      });
      return;
    }

    const updated = getInvoiceLineItem.map((row) =>
      row.slNo === editingItem.slNo ? { ...editingItem } : row,
    );
    setInvoiceLineItem(updated);
    setInvoiceData((prev) => ({ ...prev, items: updated }));
    closeItemEdit();

    const toastId = toast.loading("Updating...", { position: "top-right" });
    try {
      const res = await ItemService.updatePOFields({
        ...invoiceData,
        items: updated,
      });
      if (res?.status === 200) {
        toast.success(res?.message || "Updated successfully", {
          duration: 4000,
          position: "top-right",
        });
        props?.onsuccessdata?.({ ...invoiceData, items: updated });
      } else {
        toast.error(res?.message || "Please try again!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error while updating item:", error);
      toast.error("Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
    }
  };

  // Update the uploaded invoice details via addInvoiceFromOCR
  const handleUpdate = async () => {
    // Validate every OCR-captured header field and line item first.
    const inv = buildCurrentInvoice();
    const vErrors = validateGRNInputs(inv);
    if (vErrors.length) {
      toast.error(vErrors.join(" | "), {
        duration: 6000,
        position: "top-right",
      });
      return;
    }

    // Then verify the invoice matches the PO before persisting.
    const poErrors = await validateInvoiceAgainstPO(null, inv);
    if (poErrors.length) {
      toast.error(poErrors.join(" | "), {
        duration: 6000,
        position: "top-right",
      });
      return;
    }

    const toastId = toast.loading("Loading...", { position: "top-right" });
    try {
      setDisabled(true);
      const payload = {
        data: {
          vendorCode: inv?.vendorCode,
          vendorName: inv?.vendorName,
          purchaseTypeCode: inv?.purchaseType,
          purchaseOrderNumber: inv?.purchaseOrderNumber || "",
          purchasingDocumentNr:
            inv?.purchasingDocumentNr || props?.invoiceinfo?.purchasingDocumentNr,
          vendorInvoiceNo: inv?.vendorInvoiceNo,
          vendorInvoiceDate: inv?.vendorInvoiceDate,
          purchasingDocumentDate: inv?.purchasingDocumentDate,
          vendorTotalInvoiceValue: inv?.vendorTotalInvoiceValue,
          currency: inv?.currency,
          currencyCode: inv?.currencyCode,
          paymentTerms: inv?.paymentTerms,
          companyCode: inv?.companyCodeCode || inv?.companyCode,
          items: (inv?.items || []).map((line) => ({
            purchasingDocumentNr: inv?.purchasingDocumentNr,
            purchasingDocumentItemNr: line?.purchasingDocumentItemNr,
            grnNr: line?.grnNr,
            grnItemNr: line?.grnItemNr,
            materialCode: line?.materialCode || line?.itemCode,
            materialDescription: line?.materialDescription || line?.description,
            invoiceQuantity: line?.invoiceQuantity ?? line?.quantity,
            unitPrice: line?.unitPrice ?? line?.rate,
            orderPriceUnit: line?.orderPriceUnit,
            uOM: line?.uOM || line?.unit,
            netValue: line?.netValue ?? line?.total,
            taxCode: line?.taxCode,
            taxAmount: line?.taxAmount,
            ...(activeCustomFieldValues(line) || {}),
          })),
          imageResponse: inv?.imageResponse || {},
          attachmentId: inv?.attachmentId || inv?.invoiceBillDocument,
        },
      };
      const item = await ItemService.addInvoiceFromOCR(payload);
      if (item?.status === 200) {
        const invNo =
          invoiceData?.vendorInvoiceNo ||
          ocrInvoiceData?.vendorInvoiceNo ||
          payload?.data?.vendorInvoiceNo ||
          "";
        modalData.successMsg = invNo ? `${item?.message}` : item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();
        setWasModalShown(true);
        props?.onsuccessdata?.(payload.data);
        // dispatch(getInvoiceList());
      } else {
        toast.error(item?.message || "Please try again!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error while creating GRN:", error);
      toast.error("Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
      setDisabled(false);
    }
  };

  // Always resolves with the PO header for the current PO (or null).
  // The modal stays mounted across opens, so we clear stale header data from a
  // previously-opened PO BEFORE fetching, otherwise validation would compare the
  // new invoice against the wrong PO.
  const loadInitialPageData = async () => {
    // setLoading(true);

    if (props?.invoiceinfo?.purchasingDocumentNr) {
      let obj = {
        documentNumber: props?.invoiceinfo?.purchasingDocumentNr,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      setHeaderData(null);
      let loaded = null;
      await ItemService.getPurchaseOrderDetail(obj).then((item) => {
        // console.log(">> Details res!", item);
        if (item?.status === 200) {
          // setHeaderData(item?.data);
          setHeaderData(item?.data);
          loaded = item?.data;
          // dispatch(addPoSelectedDetails(item?.data));
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
      return loaded;

      // setLoading(false);
    }
  };
  useEffect(() => {
    loadInitialPageData();
    // eslint-disable-next-line
  }, [props]);

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton onHide={handleCancel}>
        <Modal.Title id="contained-modal-title-vcenter">
          Invoice Confirmation - {parentInfo?.purchasingDocumentNr}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col
            xs={6}
            md={3}
            lg={3}
            className="d-flex justify-content-end mr-2 mb-2"
          >
            {!file && (
              <button onClick={selectFile} className="btnTable">
                <i className="bi bi-upload mr-2"></i>
                Upload Invoice
              </button>
            )}

            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />

            {file && (
              <>
                {!uploadStatus && (
                  <button className="btnTable" onClick={uploadInvoice}>
                    <i className="bi bi-upload mr-2"></i>
                    Upload
                  </button>
                )}

                {uploadStatus && (
                  <button className="btnTable" disabled={true}>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </button>
                )}
              </>
            )}
          </Col>

          {file && (
            <Col xs={6} md={3} lg={3} className="mb-2 ml-2">
              <button className="btnDelete" onClick={cancelInvoice}>
                <i className="bi bi-x-circle"></i>
              </button>
            </Col>
          )}
        </Row>
        <Row className="commTopButtonRightLeftPadding">
          <Col xs={6} md={6} lg={6}>
            {file && (
              <p className="">
                File: <b>{file.name}</b>{" "}
              </p>
            )}
          </Col>
        </Row>

        {/* Upload invoice details */}
        {ocrInvoiceData && Object.keys(ocrInvoiceData).length > 0 ? (
          <>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">UI</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">
                        {" "}
                        Uploaded Invoice details
                      </span>
                      <span className="subHeaderTitle">Invoice details</span>
                    </Col>
                    {!viewInvoiceDataStatus && (
                      <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                        {/* <Col
                      xs={6}
                      md={6}
                      lg={6}
                      className="d-flex justify-content-end mr-2 mt-1"
                    >
                      {file && (
                        <p>
                          File: <b>{file.name}</b>{" "}
                        </p>
                      )}
                    </Col> */}
                        {/*  <Col xs={6} md={3} lg={3} className="">
                      {!file && (
                        <button onClick={selectFile} className="btnTable">
                          <i className="bi bi-upload mr-2"></i>
                          Select Invoice
                        </button>
                      )}
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />

                      {file && (
                        <>
                          {!uploadStatus && (
                            <button
                              className="btnTable"
                              onClick={uploadInvoice}
                            >
                              <i className="bi bi-upload mr-2"></i>
                              Upload
                            </button>
                          )}

                          {uploadStatus && (
                            <button className="btnTable" disabled={true}>
                              <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                              Loading...
                            </button>
                          )}
                        </>
                      )}
                    </Col>
                    {file && (
                      <Col xs={6} md={1} lg={1} className="">
                        <button className="btnDelete" onClick={cancelInvoice}>
                          <i className="bi bi-x-circle"></i>
                        </button>
                      </Col>
                    )} */}
                      </Col>
                    )}
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            {/* <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Purchase Order Code"
                                name="purchasingDocumentNr"
                                id="purchasingDocumentNr"
                                value={invoiceData?.purchasingDocumentNr || ""}
                                onChange={handleInvoiceFieldChange}
                              />
                            </Col> */}
                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Purchase Order Number"
                                name="purchaseOrderNumber"
                                id="purchaseOrderNumber"
                                value={invoiceData?.purchaseOrderNumber || ""}
                                onChange={handleInvoiceFieldChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Supplier Code"
                                name="supplierCode"
                                id="supplierCode"
                                value={invoiceData?.supplierCode || ""}
                                onChange={handleInvoiceFieldChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Invoice Number"
                                name="vendorInvoiceNo"
                                id="vendorInvoiceNo"
                                value={invoiceData?.vendorInvoiceNo}
                                onChange={handleInvoiceFieldChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Invoice Date"
                                name="vendorInvoiceDate"
                                id="vendorInvoiceDate"
                                value={invoiceData?.vendorInvoiceDate}
                                onChange={handleInvoiceFieldChange}
                              />
                            </Col>
                            {/* <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Invoice Status"
                            name="dispInvoiceStatusHeader"
                            id="dispInvoiceStatusHeader"
                            value={invoiceData?.dispInvoiceStatusHeader}
                            disabled={true}
                          />
                        </Col> */}
                            {/* <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Created By"
                            name="dispCreatedBy"
                            id="dispCreatedBy"
                            value={invoiceData?.dispCreatedBy}
                            disabled={true}
                          />
                        </Col> */}
                            {/* <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Created By Name"
                            name="dispCreatedByName"
                            id="dispCreatedByName"
                            value={invoiceData?.dispCreatedByName}
                            disabled={true}
                          />
                        </Col> */}
                            {hasValue(invoiceData?.vendorName) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Delivery"
                                  name="vendorName"
                                  id="vendorName"
                                  value={invoiceData?.vendorName}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(
                              invoiceData?.dispTotalQty || totalOrderQuantity,
                            ) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Total Qty"
                                  name="dispTotalQty"
                                  id="dispTotalQty"
                                  value={
                                    invoiceData?.dispTotalQty ||
                                    totalOrderQuantity
                                  }
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}

                            {hasValue(invoiceData?.vendorBasicValue) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Basic Price"
                                  name="vendorBasicValue"
                                  id="vendorBasicValue"
                                  // value={invoiceData?.dispBasicPrice}
                                  value={invoiceData?.vendorBasicValue}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}

                            {hasValue(invoiceData?.dispCGST) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="CGST"
                                  name="dispCGST"
                                  id="dispCGST"
                                  value={invoiceData?.dispCGST}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}

                            {hasValue(invoiceData?.dispSGST) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="SGST"
                                  name="dispSGST"
                                  id="dispSGST"
                                  value={invoiceData?.dispSGST}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.dispBasicPricePerUnit) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Basic Price Per Unit"
                                  name="dispBasicPricePerUnit"
                                  id="dispBasicPricePerUnit"
                                  value={invoiceData?.dispBasicPricePerUnit}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.dispTransporterCode) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Transporter Code"
                                  name="dispTransporterCode"
                                  id="dispTransporterCode"
                                  value={invoiceData?.dispTransporterCode}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.dispTransporterName) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Transporter Name"
                                  name="dispTransporterName"
                                  id="dispTransporterName"
                                  value={invoiceData?.dispTransporterName}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.dispVehieleRegNo) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Vehicle Reg No"
                                  name="dispVehieleRegNo"
                                  id="dispVehieleRegNo"
                                  value={invoiceData?.dispVehieleRegNo}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.dispCustomerCode) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Customer Code"
                                  name="dispCustomerCode"
                                  id="dispCustomerCode"
                                  value={invoiceData?.dispCustomerCode}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.igst) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="IGST"
                                  name="igst"
                                  id="igst"
                                  value={invoiceData?.igst}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.supplierGSTIN) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Supplier GSTIN"
                                  name="supplierGSTIN"
                                  id="supplierGSTIN"
                                  value={invoiceData?.supplierGSTIN}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.supplierPAN) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Supplier PAN"
                                  name="supplierPAN"
                                  id="supplierPAN"
                                  value={invoiceData?.supplierPAN}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.supplierName) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Supplier Name"
                                  name="supplierName"
                                  id="supplierName"
                                  value={invoiceData?.supplierName}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.supplierPhone) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Supplier Phone"
                                  name="supplierPhone"
                                  id="supplierPhone"
                                  value={invoiceData?.supplierPhone}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}
                            {hasValue(invoiceData?.taxAmountInWords) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Tax Amount in Words"
                                  name="taxAmountInWords"
                                  id="taxAmountInWords"
                                  value={invoiceData?.taxAmountInWords}
                                  onChange={handleInvoiceFieldChange}
                                />
                              </Col>
                            )}

                            {/* <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Net Value"
                            name="vendorBasicValue"
                            placeholder="0.00"
                            id="vendorBasicValue"
                            value={formatNumber(
                              invoiceData?.vendorBasicValue,
                              "comma"
                            )}
                            disabled={true}
                          />
                        </Col> */}
                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total Amount"
                                name="vendorTotalInvoiceValue"
                                placeholder="0.00"
                                id="vendorTotalInvoiceValue"
                                value={invoiceData?.vendorTotalInvoiceValue}
                                onChange={handleInvoiceFieldChange}
                              />
                            </Col>
                            {hasValue(invoiceData?.invoiceBillDocument) && (
                              <Col
                                xs={12}
                                md={4}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <p className="m-0 p-0 fw-medium">
                                  View Attachments
                                </p>
                                {invoiceData?.invoiceBillDocument ? (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(
                                        invoiceData?.invoiceBillDocument,
                                      )
                                    }
                                  />
                                ) : (
                                  "--"
                                )}
                              </Col>
                            )}
                            {/* <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <FileUploadComponentForHB
                                label="Invoice Bill Document"
                                name="invoiceBillDocument"
                                id="invoiceBillDocument"
                                multiple={false}
                                allowedTypes={[
                                  "application/pdf",
                                  "image/jpeg",
                                  "image/png",
                                  ".pdf",
                                  ".jpg",
                                  ".jpeg",
                                  ".png",
                                ]}
                                value={invoiceData?.invoiceBillDocument}
                                onSuccessUpload={(payload) =>
                                  setInvoiceData((prev) => ({
                                    ...prev,
                                    invoiceBillDocument:
                                      payload?.attachmentId ||
                                      payload?.id ||
                                      prev.invoiceBillDocument,
                                  }))
                                }
                              /> 
                            </Col>*/}
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Invoice Items */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ID</span>
                    </Col>

                    <Col xs={7} md={7} lg={7}>
                      <span className="headerTitle">Invoice Items</span>
                    </Col>
                    <Col xs={3} md={3} lg={3} className="text-end">
                      <div className="d-flex justify-content-end gap-2 flex-wrap">
                        <button
                          className="btnTable"
                          onClick={openAddFieldsModal}
                        >
                          <i className="bi bi-plus-lg mr-1"></i> Add Items
                        </button>
                        <button
                          className="btnTable"
                          onClick={openFillColumnModal}
                          disabled={!getInvoiceLineItem?.length}
                          title="Set one value for a column on all line items"
                        >
                          <i className="bi bi-chevron-double-down mr-1"></i>{" "}
                          Fill Value
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={getInvoiceLineItem.filter(
                            (row) => hasLineItemValues(row) || row?.isManualItem,
                          )}
                          // progressPending={loading}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          paginationRowsPerPageOptions={
                            SupplierConstants.ROW_PER_PAGE
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : uploadStatus ? (
          <div className="text-center py-4">
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
            Extracting invoice details...
          </div>
        ) : null}

        {/* Header Details */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">HD</span>
                </Col>
                <Col xs={12} md={2} lg={2}>
                  <span className="headerTitle">Header Details</span>
                  <span className="subHeaderTitle"> </span>
                </Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${
                isCardVisible2 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4">
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Document Number"
                      name="purchasingDocumentNr"
                      placeholder=""
                      value={getHeaderData?.purchasingDocumentNr || ""}
                      disabled={true}
                    />
                  </Col>
                  {/* <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Status"
                                  name="statusHeader"
                                  placeholder=""
                                  value={getHeaderData?.statusHeader || ""}
                                  disabled={true}
                                />
                              </Col> */}
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Document Date"
                      name="purchasingDocumentDate"
                      placeholder=""
                      value={getHeaderData?.purchasingDocumentDate || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Net Value"
                      name="purchasingDocumentValue"
                      placeholder=""
                      value={currencyFormat(
                        Number(getHeaderData?.purchasingDocumentValue).toFixed(
                          2,
                        ),
                      )}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Currency"
                      name="currency"
                      placeholder=""
                      value={`${getHeaderData?.currencyCode} - ${getHeaderData?.currency}`}
                      disabled={true}
                    />
                  </Col>

                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Vendor Code"
                      name="vendorCode"
                      placeholder=""
                      value={getHeaderData?.vendorCode || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Vendor Name"
                      name="vendorName"
                      placeholder=""
                      value={getHeaderData?.vendorName || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Payment Terms"
                      name="paymentTerms"
                      placeholder=""
                      value={getHeaderData?.paymentTerms || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Inco Terms"
                      name="incoTerms"
                      placeholder=""
                      value={getHeaderData?.incoTerms || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Company Code "
                      name="companyCodeCode"
                      id="companyCodeCode"
                      value={getHeaderData?.companyCodeCode}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Purchse Type"
                      name="purchasingRemark"
                      placeholder=""
                      value={getHeaderData?.purchaseType || ""}
                      disabled={true}
                    />
                  </Col>
                  {/* <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding mt-4 pt-3"
                  >
                    <div>
                      <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
                        Header Text
                      </label>
                      <span
                        style={{ marginLeft: "15px" }}
                        // onClick={() =>
                        //   headerTextShowModal(getHeaderData?.headerTextData)
                        // }
                      >
                        <i className="bi bi-calendar2-week iconTable"></i>
                      </span>
                      <span className="suppliersIcon">
                        {" "}
                        {getHeaderData?.headerTextData?.length || 0}{" "}
                      </span>
                    </div>
                  </Col> */}
                </Row>
              </div>
            </div>
          </div>
        </div>
        <FileViewerModal
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
        />
        <SuccessRegisterModal
          show={getShowSuccessModal}
          onHide={() => hideSuccessModal()}
          modaldata={getModalInfo}
          aftersuccess={Constants.POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE}
        />

        {/* Line-item edit popup */}
        <Modal
          show={showItemModal}
          onHide={closeItemEdit}
          size="md"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton={handleCancel}>
            <Modal.Title id="contained-modal-title-vcenter">
              Edit Invoice Item
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              {hasValue(editingItem?.lineNo) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Line No"
                    name="lineNo"
                    id="editLineNo"
                    value={editingItem?.lineNo ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              <Col
                xs={12}
                md={6}
                lg={6}
                className="commTopButtonRightLeftPadding"
              >
                <InputField
                  className="inputBox"
                  label="Item Code"
                  name="itemCode"
                  id="editItemCode"
                  value={editingItem?.itemCode || ""}
                  onChange={handleItemFieldChange}
                />
              </Col>
              {hasValue(editingItem?.description) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Description"
                    name="description"
                    id="editDescription"
                    value={editingItem?.description || ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.hsnSac) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="HSN/SAC"
                    name="hsnSac"
                    id="edithsnSac"
                    value={editingItem?.hsnSac || ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              <Col
                xs={12}
                md={6}
                lg={6}
                className="commTopButtonRightLeftPadding"
              >
                <InputField
                  className="inputBox"
                  label="Qty"
                  type="number"
                  name="quantity"
                  id="editQuantity"
                  value={editingItem?.quantity ?? ""}
                  onChange={handleItemFieldChange}
                />
              </Col>
              {hasValue(editingItem?.unit) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Unit"
                    name="unit"
                    id="editUnit"
                    value={editingItem?.unit || ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              <Col
                xs={12}
                md={6}
                lg={6}
                className="commTopButtonRightLeftPadding"
              >
                <InputField
                  className="inputBox"
                  label="Rate"
                  type="number"
                  name="rate"
                  id="editRate"
                  value={editingItem?.rate ?? ""}
                  onChange={handleItemFieldChange}
                />
              </Col>
              {hasValue(editingItem?.discount) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Discount"
                    type="number"
                    name="discount"
                    id="editDiscount"
                    value={editingItem?.discount ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.taxableValue) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Taxable Value"
                    type="number"
                    name="taxableValue"
                    id="editTaxableValue"
                    value={editingItem?.taxableValue ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.cgstPercent) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="CGST %"
                    type="number"
                    name="cgstPercent"
                    id="editCgstPercent"
                    value={editingItem?.cgstPercent ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.cgstAmount) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="CGST Amount"
                    type="number"
                    name="cgstAmount"
                    id="editCgstAmount"
                    value={editingItem?.cgstAmount ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.sgstPercent) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="SGST %"
                    type="number"
                    name="sgstPercent"
                    id="editSgstPercent"
                    value={editingItem?.sgstPercent ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.sgstAmount) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="SGST Amount"
                    type="number"
                    name="sgstAmount"
                    id="editSgstAmount"
                    value={editingItem?.sgstAmount ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.igstPercent) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="IGST %"
                    type="number"
                    name="igstPercent"
                    id="editIgstPercent"
                    value={editingItem?.igstPercent ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.igstAmount) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="IGST Amount"
                    type="number"
                    name="igstAmount"
                    id="editIgstAmount"
                    value={editingItem?.igstAmount ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.cess) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Cess"
                    type="number"
                    name="cess"
                    id="editCess"
                    value={editingItem?.cess ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
              {hasValue(editingItem?.total) && (
                <Col
                  xs={12}
                  md={6}
                  lg={6}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Total Amount"
                    type="number"
                    name="total"
                    id="editTotal"
                    value={editingItem?.total ?? ""}
                    onChange={handleItemFieldChange}
                  />
                </Col>
              )}
            </Row>
            <Row className="mt-4">
              <Col
                lg={{ span: 2, offset: 8 }}
                className="d-flex justify-content-end"
              >
                <button
                  className="btnTable btn-danger mb-2"
                  onClick={closeItemEdit}
                >
                  Cancel
                </button>
              </Col>
              <Col lg={2} className="d-flex justify-content-end mb-2">
                <button className="btnTable" onClick={commitItemEdit}>
                  Save Item
                </button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        {/* Add Items popup — choose default fields and/or create custom fields
            that become editable columns of the Invoice Items grid. */}
        <Modal
          show={showAddFieldsModal}
          onHide={closeAddFieldsModal}
          size="md"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton={closeAddFieldsModal}>
            <Modal.Title id="contained-modal-title-vcenter">
              Add Items
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="subHeaderTitle mb-3">
              Choose fields to show as columns in Invoice Items
            </p>

            <div className="mb-3">
              <h6 className="fw-bold">Default fields</h6>
              <Row>
                {LINE_ITEM_FIELD_OPTIONS.map((field) => {
                  const isChecked = fieldDraft.some((f) => f.key === field.key);
                  return (
                    <Col xs={6} md={6} lg={4} key={field.key} className="mb-1">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`draft-${field.key}`}
                          checked={isChecked}
                          onChange={() => toggleDefaultField(field)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`draft-${field.key}`}
                        >
                          {field.label}
                        </label>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>

            <div className="mt-3">
              <h6 className="fw-bold">Custom fields</h6>
              <Row className="align-items-end">
                <Col xs={12} md={8}>
                  <InputField
                    className="inputBox"
                    label=""
                    name="customFieldLabel"
                    placeholder="e.g. Remarks, Batch No."
                    value={customFieldLabel}
                    onChange={(e) => setCustomFieldLabel(e.target.value)}
                  />
                </Col>
                <Col xs={12} md={4} className="mt-2">
                  <button
                    className="btnTable"
                    type="button"
                    onClick={addCustomField}
                  >
                    <i className="bi bi-plus-lg mr-1"></i> Add
                  </button>
                </Col>
              </Row>
              {fieldDraft.filter((f) => f.isCustom).length > 0 && (
                <ul className="list-unstyled mt-2 mb-0">
                  {fieldDraft
                    .filter((f) => f.isCustom)
                    .map((f) => (
                      <li
                        key={f.key}
                        className="d-flex justify-content-between align-items-center mb-1"
                      >
                        <span>
                          <i className="bi bi-tag mr-1"></i>
                          {f.label}
                        </span>
                        <button
                          type="button"
                          className="btnDelete"
                          onClick={() => removeDraftField(f.key)}
                          title="Remove field"
                        >
                          <i className="bi bi-x-circle"></i>
                        </button>
                      </li>
                    ))}
                </ul>
              )}
            </div>

            <div className="mt-3 pt-3 border-top">
              <h6 className="fw-bold">Add new item</h6>
              <p className="subHeaderTitle mb-2">
                Add a blank line item to the Invoice Items grid. Values entered
                inline are saved with the GRN/invoice.
              </p>
              <button
                className="btnTable"
                type="button"
                onClick={addNewLineItem}
              >
                <i className="bi bi-plus-lg mr-1"></i> Add New Item
              </button>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btnTable btn-danger" onClick={closeAddFieldsModal}>
              Cancel
            </button>
            <button className="btnTable" onClick={applyFields}>
              Apply
            </button>
          </Modal.Footer>
        </Modal>

        {/* Fill Value popup — type one value per grid column and apply it to
            every current line item in that column at once. */}
        <Modal
          show={showFillColumnModal}
          onHide={closeFillColumnModal}
          size="md"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton={closeFillColumnModal}>
            <Modal.Title id="contained-modal-title-vcenter">
              Fill Value for Columns
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
            <p className="subHeaderTitle mb-3">
              Enter a value for a column and it will be filled on all current
              line items at once. Leave a field blank to skip that column.
            </p>

            {activeGridFields.length === 0 ? (
              <p className="text-muted mb-0">
                No columns are shown in the Invoice Items grid yet. Use{" "}
                <strong>Add Items</strong> to add columns first.
              </p>
            ) : (
              activeGridFields.map((f) => (
                <div key={f.key} className="mb-2">
                  <InputField
                    className="inputBox"
                    label={f.label}
                    type={f.type === "number" ? "number" : "text"}
                    name={`fill-${f.key}`}
                    id={`fill-${f.key}`}
                    placeholder={`Value for ${f.label}`}
                    value={columnFillDraft[f.key] ?? ""}
                    onChange={(e) => handleFillFieldChange(f.key, e.target.value)}
                  />
                </div>
              ))
            )}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btnTable btn-danger"
              onClick={closeFillColumnModal}
            >
              Cancel
            </button>
            <button
              className="btnTable"
              onClick={applyColumnFill}
              disabled={activeGridFields.length === 0}
            >
              <i className="bi bi-chevron-double-down mr-1"></i> Apply to all
              rows
            </button>
          </Modal.Footer>
        </Modal>

        {!viewInvoiceDataStatus && (
          <Row className="my-4 ">
            <Col
              lg={{ span: 2, offset: 8 }}
              className="d-flex justify-content-end"
            >
              <button
                className="btnTable btn-danger mb-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </Col>
            <Col lg={2} className="d-flex justify-content-end mb-2">
              <button
                className="btnTable"
                onClick={handleSave}
                disabled={disabled}
              >
                Save
              </button>
            </Col>
          </Row>
        )}
        {viewInvoiceDataStatus && (
          <Row className="my-4 ">
            <Col
              lg={{ span: 2, offset: 8 }}
              className="d-flex justify-content-end"
            >
              <button
                className="btnTable btn-danger mb-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </Col>
            <Col lg={2} className="d-flex justify-content-end mb-2">
              <button
                className="btnTable"
                onClick={handleUpdate}
                disabled={disabled}
              >
                Update
              </button>
            </Col>
          </Row>
        )}
      </Modal.Body>
    </Modal>
  );
});

export default GRNInvoiceUploadModal;
